import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ForbiddenBar.css';

/* Barre de refus d'écriture — pleine largeur, en haut de l'écran.

   Le serveur répondait « Droit d'écriture insuffisant » et l'application
   l'affichait en petit, en bas à droite ou au-dessus d'un tableau : invisible en
   pratique. L'utilisateur croyait à une panne et recommençait.

   Alimentée par l'événement `palestre:forbidden`, émis par le client API sur tout
   403 en écriture — donc valable pour TOUS les écrans, sans code par page. */
export default function ForbiddenBar() {
  const { t } = useTranslation();
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    const onForbidden = (e) => setMsg(e.detail || null);
    window.addEventListener('palestre:forbidden', onForbidden);
    return () => window.removeEventListener('palestre:forbidden', onForbidden);
  }, []);

  useEffect(() => {
    if (msg === null) return undefined;
    const timer = setTimeout(() => setMsg(null), 8000);
    return () => clearTimeout(timer);
  }, [msg]);

  if (msg === null) return null;
  return (
    <div className="fbd-bar" role="alert">
      <span className="fbd-bar__txt">
        <strong>{t('common:forbidden.title')}</strong>
        {' — '}
        {t('common:forbidden.text')}
      </span>
      <button type="button" className="fbd-bar__x" onClick={() => setMsg(null)} aria-label={t('common:actions.close', 'Fermer')}>×</button>
    </div>
  );
}
